/**
 * Rich Nav - menus
 * @module richNav
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

import Keyboard from './keyboard';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'richNav';
export const GLOBAL_CLASS = '.js-global__nav';
export const GLOBAL_ACCOUNT_CLASS = '.js-global__account';
// export const GLOBAL_ACCOUNT_SETTINGS_CLASS = '.js-global__account__settings';
export const MAIN_NAV = '#rich-nav-container';
export const RICH_NAV_ID = '#js-rich-nav';
export const SUB_NAV_MENU = '.sub-menu__wrapper';
export const MENU_WRAPPER = '.js-menu-wrapper';
export const CLICK_EVENT = 'click';
export const WOMENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=revolvemobile&loadAll=true&richNav=true';
export const MENS_ENDPOINT_URL = '/r/ipadApp/MenuTree.jsp?deviceType=revolvemobile&d=Mens&loadAll=true&richNav=true';
export const WOMENS_HOMEPAGE_URL = '/r/mobile/index_women.jsp';
export const MENS_HOMEPAGE_URL = '/r/mobile/index_men.jsp';
export const BEAUTY_HOMEPAGE_URL = '/content/lp/beauty/mobile/';

export const $burgerIcon = $('#tr-burger-icon');
export const $plpCatNavLink = $('#plp-category-nav-link');

export const DEFAULTS = {
  swapClass: '',
  swapTarget: '',
  rnItem: '.js-rich-nav',
  returnFocus: '',
  trapFocusFunc: Keyboard.trapFocus.bind(Keyboard),
  releaseFocusFunc: Keyboard.releaseFocus.bind(Keyboard),
};
/**
  * Set focus to first anchor in open side nav
  */
function openSideNavFocus(opts) {
  const $openSideNav = $('.is--open').last();
  if ($openSideNav.length > 0) {
    const $firstListItem = $openSideNav.find('.nav-side__list').first();
    // Look for anchors, buttons, and elements with tabindex not set to -1
    const $firstListItemToFocus = $firstListItem.find('button, a, [tabindex]:not([tabindex="-1"])').eq(0);
    $firstListItemToFocus[0].focus();
    opts.trapFocusFunc($openSideNav);
  } else {
    $('#rich-nav-title').find('a').first().focus();
    if (window.rcProps.richNav && window.rcProps.richNav.richMenuState) {
      opts.trapFocusFunc($('#rich-nav-container'));
    } else {
      opts.trapFocusFunc($('.main-menu__wrapper'));
    }
  }
}
/**
 * Lazy load images inside the rich navigation
 * @param {jQuery} $mainMenuContent - The container element (modal, menu, etc.)
 */
function lazyLoadImages() {
  const $mainMenuContent = $('.main-menu__content');
  const $lazyImages = $mainMenuContent.find('img[data-lazy]');
  $lazyImages.each(function () {
    const $image = $(this);
    const lazySrc = $image.data('lazy');  // Get the actual image URL from data-src
    if (lazySrc && $image.attr('src') !== lazySrc) {
      $image.attr('src', lazySrc);  // Set the src to the actual image
      $image.removeAttr('data-src');  // Optionally remove data-src to prevent future checks
    }
  });
}
/**
  * Open Rich Nav
  */
function openSideNav(opts) {
  $(RICH_NAV_ID).parent().attr('aria-modal', 'true');
  // Set focus to the first element in the current sub nav
  openSideNavFocus(opts);
  lazyLoadImages();
}
/**
  * Close Rich Nav
  */
function closeSideNav(opts) {
  $(RICH_NAV_ID).parent().attr('aria-modal', 'false');
  $('#nav-side-page-wrapper').removeClass('nav__sidebar--open');
  opts.releaseFocusFunc($('.js-menu-wrapper'), '');
}

/**
 * Create New Element
 * @param {Object} element - Elemnt used for generating New Element
 */
function createNode(element) {
  return document.createElement(element);
}
/**
 * Create New Element
 * @param {Object} parent - Parent element that items get appended to
 * @param {Object} el - Element that is appended to the parent
 */
function appender(parent, el) {
  return parent.appendChild(el);
}

function getTranslatedText(text) {
  if (!window.rcProps.richNav.textFields[text]) {
    return text;
  }

  return window.rcProps.richNav.textFields[text];
}
/**
  * Create Close Menu button
  */
function closeMenuBtn() {
  const closeButton = createNode('button');
  closeButton.className = 'js-rich-nav-close nav-side__item--close-btn action-button action-button--full u-padding-a--md';
  closeButton.innerHTML = getTranslatedText('Close Menu');
  const closeBtnWrapper = createNode('li');
  closeBtnWrapper.className = 'nav-side__item nav-side__item--close';
  appender(closeBtnWrapper, closeButton);
  return closeBtnWrapper;
}
/**
* Clone Element
* @param {Object} element - Element to clone
*/
function cloneElement(element) {
  return $(element).clone(true);
}

/**
* Error Handler
* @param {Object} response - response
*/
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

function getCurrentMenuDep() {
  if (window.rcProps.richNav && window.rcProps.richNav.richMenuState) {
    const match = window.rcProps.richNav.richMenuState[0].match(/\.(.*?)-/);
    if (match) {
      return match[1]; // womens, beauty, or mens
    }
  }
  return 'womens'; // default dep
}

function openDefaultMenu() {
  if (window.rcProps.richNav && window.rcProps.richNav.richMenuState) {
    const currentOpenMenus = window.rcProps.richNav.richMenuState;
    let i = 0;
    let parentSelector = RICH_NAV_ID;

    const tabName = getCurrentMenuDep();
    $(`#${tabName}-tab-link`).click(); // open correct tab
    for (i = (tabName === 'womens' ? 0 : 1); i < currentOpenMenus.length; i += 1) {
      $(parentSelector).find(`button[data-swap-target="${currentOpenMenus[i]}"]`).not('.return-link').click();
      parentSelector = currentOpenMenus[i];
    }
  }
}

// Method to close all submenus
function removeAllSubMenus() {
  const mainMenuContent = document.querySelector('.main-menu__content');
  const elements = document.querySelectorAll('.sub-menu__wrapper');
  mainMenuContent.classList.remove('u-hide');
  elements.forEach(element => {
    element.classList.remove('is--open');
    $(element).children().addClass('u-hide'); // hide for a11y - beauty revieve banner issue
  });
}

function hidePreviousContent($subNavContainer, $mainContentWrapper, isBackButton) {
  $subNavContainer.on('transitionend webkitTransitionEnd oTransitionEnd', () => {
    if ($mainContentWrapper) {
      $mainContentWrapper.addClass('u-hide');
    } else {
      $subNavContainer.find('.sub-menu__list').addClass('u-hide');
      $subNavContainer.children().addClass('u-hide'); //  hide for a11y - Beauty Revieve Banner issue
    }
    if (isBackButton) {
      $('#rich-nav-container').children().last().remove();
      $subNavContainer.find('.sub-menu__list').addClass('u-hide'); // hide for a11y
    }
    $subNavContainer.off('transitionend webkitTransitionEnd oTransitionEnd');
  });
}

/**
 * Toggle Class
 * @param {Object} options - Options used for wiring up the List
 */
function toggleMenuClass($el, $currentElement) {
  const dataSwapTarget = $($currentElement).data('swapTarget');
  const isBackButton = $currentElement.hasClass('js-rich-nav-back');
  // If a data-swap-target attribute was used instead of href
  if (isBackButton) {
    // back level
    $(dataSwapTarget).last().find('.sub-menu__list').removeClass('u-hide');
    const $subNavContainer = $currentElement.closest('.sub-menu__wrapper');
    hidePreviousContent($subNavContainer, null, isBackButton);
    $currentElement.closest('.sub-menu__wrapper').removeClass('is--open');
  } else if (!isBackButton) {
    // next level
    $(dataSwapTarget).addClass('is--open');
    $(dataSwapTarget).find('.sub-menu__list').removeClass('u-hide');
    $(dataSwapTarget).children().removeClass('u-hide'); // hide for a11y - Beauty Revieve Banner issue
    const $mainContentWrapper = $currentElement.closest('.main-menu__content');
    if ($mainContentWrapper.length) {
      hidePreviousContent($(dataSwapTarget), $mainContentWrapper);
    }
  }
}
/**
 * Scroll Element to Top
 * @param {Object} element - Element that is being checked
 */
function scrollToTop(element) {
  element.animate({ scrollTop: 0 }, 'fast');
}
/**
 * Build Wrapper Element - ie: div
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} parentListDataId - string representing parent id attribute
 */
function buildWrapperElement(
  elem,
  dataElement,
  dataId,
) {
  const el = createNode(`${elem}`);
  el.className = `sub-menu__wrapper js-menu-wrapper ${dataId}-menu__${dataElement}`;
  const fasterSubMenuClass = window.rcProps.richNav.fasterSubMenuAnimationClass;
  if (fasterSubMenuClass) {
    el.className = `${el.className} ${fasterSubMenuClass}`;
  }
  el.dataset.element = `${dataElement}`;
  return el;
}
/**
 * Global elements to clone
 */
function cloneGLobalElements() {
  const globalNav = $(GLOBAL_CLASS);
  const globalNavClone = cloneElement(globalNav);

  return globalNavClone;
}

/**
 * Global elements to clone
 */
function cloneGLobalAccountElements(isMens) {
  const globalAccountNav = $(GLOBAL_ACCOUNT_CLASS);
  const globalAccountNavClone = cloneElement(globalAccountNav);

  const myFavLink = globalAccountNavClone.find('.js-my-fav-link');
  const myFavHref = myFavLink.data('baseUrl');
  if (isMens) {
    myFavLink.attr('href', `${myFavHref}&d=Mens&departmentFilter=Mens`);
  } else {
    myFavLink.attr('href', myFavHref);
  }
  return globalAccountNavClone;
}

/**
 * Global elements to clone
 */
// function cloneGLobalAccountSettingsElements() {
//   const globalAccountSettingsNav = $(GLOBAL_ACCOUNT_SETTINGS_CLASS);
//   const globalAccountSettingsNavClone = cloneElement(globalAccountSettingsNav);
//   globalAccountSettingsNavClone.find('.return-link').parent('li').remove();
//   return globalAccountSettingsNavClone;
// }
/**
 * Build List Element - ie: ul
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 * @param {string} dataId - Data id of menu
 */
function buildListElement(elem, dataElement, dataId, nameDisplay) {
  const el = createNode(`${elem}`);
  el.className = 'nav-side__list sub-menu__list';
  // Set id to mens or womens - mens logic will be needed
  el.dataset.id = dataId;
  el.dataset.category = dataElement;
  el.dataset.nameDisplay = nameDisplay;
  return el;
}
/**
 * Build List Item Link - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItemElement(elem) {
  const el = createNode(`${elem}`);
  el.className = 'nav-side__item';
  return el;
}
/**
 * Build List Item Link - ie: li > button
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItemButtonElement(dataElement, dataId, htmlContent, swapTargetID) {
  const el = createNode('button');
  el.className = 'nav-side__link nav-side__link--main return-link js-rich-nav js-rich-nav-back';
  el.dataset.swapClass = 'is--open';
  if (typeof swapTargetID !== 'undefined') {
    el.dataset.swapTarget = `.${dataId}-menu__${swapTargetID}`;
  } else {
    el.dataset.swapTarget = `.${dataId}-menu__${dataElement}`;
  }
  el.dataset.element = dataElement;
  el.innerHTML = htmlContent;
  return el;
}
/**
 * Build List Items and Links - ie: li > a
 * @param {Object} elem - Elemnt used for generating New Element
 * @param {Object} dataElement - Data element that is being checked
 */
function buildListItems(data, ul, dataElement, dataId, dataCategory, dataLevel) {
  let categories = {};
  if (dataElement === 'new' || dataCategory === 'new') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'new');
  } else if ((dataElement === 'sale' || dataCategory === 'sale') && dataCategory !== 'beauty') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'sale');
  } else if ((dataElement === 'featured-shops' && dataCategory !== 'clothing') || dataCategory === 'featured-shops') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'featured shops');
  } else if (dataElement === 'most-wanted' || dataCategory === 'most-wanted') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'most wanted');
  } else if (dataElement === 'what-to-wear' && dataCategory !== 'clothing') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'what to wear');
  } else if (dataElement === 'festival') {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'festival');
  } else {
    categories = data.filter(cat => cat.catName.toLowerCase() === 'categories');
  }
  const subCategories = categories[0].subCategoryList;

  let links;
  // if level one go deeper and get sub sub categories
  if (dataLevel === '1' && dataCategory !== 'sale') {
    // should check parent/category
    const subSubCats = subCategories
    .filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataCategory);
    const subSubSubLinks = subSubCats[0].subCategoryList;

    // links = subSubLinks[0].subCategoryList;
    const deepLinks = subSubSubLinks.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement);
    links = deepLinks[0].subCategoryList;
  } else if (dataLevel === '2') {
    // CLEAN THIS UP CURRENTLY SPECIFIC TO BEAUTY
    let subSubCats = subCategories.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === 'beauty');
    if (dataCategory === 'activewear' || dataCategory === 'swimsuits---cover-ups') {
      subSubCats = subCategories.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === 'clothing');
    }
    if (dataCategory === 'home') {
      subSubCats = subCategories.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === 'home');
      const subSubSubCats = subSubCats[0].subCategoryList;
      const elementLinks = subSubSubCats.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement);
      links = elementLinks[0].subCategoryList;
    } else {
      const subSubSubCats = subSubCats[0].subCategoryList;

      const deepLinks = subSubSubCats.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataCategory);
      const deeperLinks = deepLinks[0].subCategoryList;

      const superDeepLinks = deeperLinks.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement);
      links = superDeepLinks[0].subCategoryList;
    }
  } else {
    // Go deeper if it's not New
    let subSubCats;
    if (dataElement !== 'new' && dataElement !== 'sale' && dataElement !== 'featured-shops'
        && dataElement !== 'most-wanted' && dataElement !== 'what-to-wear' && dataElement !== 'festival') {
      subSubCats = subCategories.filter(item => item.catName.replace(/[^A-Z0-9]/ig, '-').toLowerCase() === dataElement);
      links = subSubCats[0].subCategoryList;
    } else {
      subSubCats = subCategories;
      if (dataElement === 'new') {
        // Get Arrival Dates subCategory List
        const arrivalSubCats = subSubCats[0].subCategoryList;
        // FIlter down to Category Names
        const arrivalLinksArray = arrivalSubCats.filter(item => item.catName);
        // Get Category Array from "new"
        const category = subSubCats[1];
        // Push category on to arrival dates links
        arrivalLinksArray.push(category);
        if (subSubCats.length > 2) {
          const designer = subSubCats[2];
          arrivalLinksArray.push(designer);
        }

        // Set links to Arrivals links array
        links = arrivalLinksArray;
      } else {
        links = subSubCats;
      }
    }
  }
  links = links.filter(link => link !== undefined);
  // create html markup for list items
  links.map((link) => {
    const categoryName = link.catName.replace(/[^A-Z0-9]/ig, '-');
    // create list items for anchor tags
    const li = createNode('li');
    li.className = 'nav-side__item';
    if (link.isSubHeader) {
      li.className = 'nav-side__item nav-side__item--sub-title';
    }

    // create anchor tags or button tag
    const a = createNode('a');
    const btn = createNode('button');

    if (link.subCategoryList === undefined) {
      a.className = 'nav-side__link';
      a.href = link.href;
      a.innerHTML = link.nameDisplay;
      if (link.isSubHeader) {
        li.innerHTML = link.nameDisplay;
      } else {
        appender(li, a);
      }
    } else {
      // create a button
      btn.className = 'nav-side__link nav-side__link--category js-rich-nav';
      btn.dataset.swapClass = 'is--open';
      btn.dataset.swapTarget = `.${dataId}-menu__${categoryName}`;
      btn.dataset.element = categoryName;
      btn.dataset.level = link.level;
      btn.innerHTML = link.nameDisplay;
      appender(li, btn);
    }
    appender(ul, li);
    return true;
  });
}
/**
 * Create New Navigation Menu
 * @param {Object} $currentElement - Elemnt used for generating New Menu
 */
function generateMarkup(
  $currentElement,
  dataElement,
  properDataElement,
  dataLevel,
  dataCategory,
  properDataCategory,
  $parentList,
  parentListDataId,
  parentWrapperElement,
  wrapperHeight,
  lastWrapperHeight) {
  // create div wrapper for ul list and set height
  const div = buildWrapperElement(
    'div',
    dataElement,
    parentListDataId,
    wrapperHeight,
    lastWrapperHeight,
  );
  // create ul for list items with classes
  const ul = buildListElement('ul', dataElement, parentListDataId, $currentElement.html());
  // Add ul to wrapping div
  appender(div, ul);
  // clone my account and customer care list
  if ($(GLOBAL_CLASS)[0]) {
    const globalNavigation = cloneGLobalElements();
    // Add My Account and Cutomer care after ul
    if ($currentElement.html() !== 'My Settings') {
      const globalAccountNavigation = cloneGLobalAccountElements(parentListDataId === 'mens');
      appender(div, globalAccountNavigation[0]);
    }
    appender(div, globalNavigation[0]);
    // if ($(GLOBAL_ACCOUNT_SETTINGS_CLASS)[0]) {
    //   const globalAccountSettingsNavigation = cloneGLobalAccountSettingsElements();
    //   appender(div, globalAccountSettingsNavigation[0]);
    // }
  }

  if (parentListDataId === 'beauty' && dataCategory === '') { // create 'main menu' back link for beauty menu as it is dynamically built menu
    const li = buildListItemElement('li');
    const btn = buildListItemButtonElement(dataElement, parentListDataId, getTranslatedText('main menu'));
    appender(li, btn);
    appender(ul, li);
  }

  // create category back Link
  if (dataCategory !== '') {
    const categoryLink = buildListItemElement('li');
    categoryLink.classList.add('nav-side__link--main');
    const categoryButton = buildListItemButtonElement(
      dataElement,
      parentListDataId,
      $parentList[0].dataset.nameDisplay,
      $parentList[0].dataset.category,
    );
    appender(categoryLink, categoryButton);
    appender(ul, categoryLink);
  }

  // create subCategory List Item without hyphens for display purposes
  const subCategoryLink = buildListItemElement('li');

  if ($currentElement.html() && ($currentElement.html().toLowerCase() === getTranslatedText('beauty') || $currentElement.html().toLowerCase() === getTranslatedText('collections'))) {
    const subCategoryListItem = createNode('a');
    if ($currentElement.html().toLowerCase() === getTranslatedText('beauty')) {
      subCategoryListItem.className = 'nav-side__link nav-side__link--main js-rich-nav-hp js-rich-nav-beauty js-active';
      subCategoryListItem.href = '/content/lp/beauty/mobile/?navsrc=main_hm';
    } else {
      subCategoryListItem.className = 'nav-side__link nav-side__link--main';
      subCategoryListItem.href = '/content/lp/collections-shop/mobile/?navsrc=main_hm';
    }
    subCategoryListItem.innerHTML = $currentElement.html();
    $(subCategoryListItem).click(window.richNavHpClickHandler);
    appender(subCategoryLink, subCategoryListItem);
  } else {
    const subCategoryListItem = createNode('span');
    subCategoryListItem.className = 'nav-side__link nav-side__link--no-link nav-side__link--main';
    subCategoryListItem.innerHTML = $currentElement.html();
    appender(subCategoryLink, subCategoryListItem);
  }
  appender(ul, subCategoryLink);

  // Append revieve banner if available
  if (parentListDataId === 'beauty') {
    fetch(window.rcProps.richNav.revieveBannerHref)
      .then(handleErrors)
      .then(response => response.text())
      .then((data) => {
        if (data) {
          ul.insertAdjacentHTML('afterend', data);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  }

  // Set proper variables for mens and womens data
  const endpoint = (parentListDataId === 'womens' || parentListDataId === 'beauty') ? WOMENS_ENDPOINT_URL : MENS_ENDPOINT_URL;
  const storeData = (parentListDataId === 'womens' || parentListDataId === 'beauty') ? 'womens-data' : 'mens-data';

  if (sessionStorage.getItem(storeData)) {
    const data = JSON.parse(sessionStorage.getItem(storeData));
    // Build List Items from data object in local storage
    buildListItems(data, ul, dataElement, parentListDataId, dataCategory, dataLevel);
    const closeMenu = closeMenuBtn();
    appender(ul, closeMenu);
  } else {
    // const womensData = getEndpoint(WOMENS_ENDPOINT_URL);
    fetch(endpoint, { credentials: 'same-origin' })
    .then(handleErrors)
    .then(response => response.json())
    .then((data) => {
      // Build List Items from data object
      buildListItems(data, ul, dataElement, parentListDataId, dataCategory, dataLevel);
      // Create and Append Close Menu button
      const closeMenu = closeMenuBtn();
      appender(ul, closeMenu);
      // set data in local storage
      sessionStorage.setItem(storeData, JSON.stringify(data));
    })
    .catch((error) => {
      console.log(error);// eslint-disable-line no-console
    });
  }
  lazyLoadImages();

  return div;
}

/**
/**
 * Handles the click event when a Menu Item has been interacted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
const itemClickHandler = (
  { currentTarget },
  $el,
  wrapperHeight,
  opts) => {
  const $currentElement = $(currentTarget);
  // Get current parent ul div wrapper data element
  const parentWrapperElement = $currentElement.closest('.js-menu-wrapper')[0].dataset.element;
  // Get current parent ul
  let $parentList = $currentElement.parents('ul');
  let dataLevel = $currentElement.attr('data-level');
  const dataElement = $currentElement.attr('data-element').replace(/[^A-Z0-9]/ig, '-').toLowerCase(); // current element clicked
  // generate the proper classes and data for menus
  // Get current parent ul category data attribute
  let dataCategory = $parentList[0].dataset.category;
  // Some links are in multiple places (e.g., top-level and under Accessories)
  // Keep it consistent by only generating top-level
  if (dataCategory === 'clothing' && dataElement === 'dresses') {
    $parentList = $('#womens-menu__content').children('ul'); // dresses are available for women's dep only
    dataCategory = $parentList && $parentList.length > 0 ? $parentList[0].dataset.category : '';
    dataLevel = 0;
  }
  const properDataCategory = dataCategory.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Get current parent ul id data attribute
  let parentListDataId = $parentList[0].dataset.id;
  const properDataElement = dataElement.replace(/-{3}/ig, ' & ').replace(/-/ig, ' ');
  // Object Level value
  const swapTarget = $currentElement.data('swapTarget');
  const subMenu = $el.find(swapTarget);
  // Get height of last sub menu
  const lastWrapperHeight = $currentElement.parents(SUB_NAV_MENU).outerHeight(true);
  // Release trap focus
  opts.releaseFocusFunc($('.js-menu-wrapper'), $(opts.returnFocus));
  // if clicking womens or main menu
  if ($currentElement.html() === getTranslatedText('womens')
      || $currentElement.html() === getTranslatedText('main menu')
      || $currentElement.data('returnToMain')) {
    $('.main-menu__content').removeClass('u-hide');
    $(SUB_NAV_MENU).removeClass('is--open');
    hidePreviousContent($(SUB_NAV_MENU));
    openSideNavFocus(opts);
    return;
  }

  if ($currentElement.html() === getTranslatedText('beauty') && dataCategory && dataCategory !== 'beauty') {
    $('.main-menu__content').removeClass('u-hide');
    // $('.sub-menu__wrapper').not('.beauty-menu__beauty').removeClass('is--open');
    $(SUB_NAV_MENU).removeClass('is--open');
    hidePreviousContent($(SUB_NAV_MENU));
    openSideNavFocus(opts);
    return;
  }

  if ($currentElement.html() === getTranslatedText('mens') && dataCategory && dataCategory !== 'mens') {
    $('.main-menu__content').removeClass('u-hide');
    $(SUB_NAV_MENU).removeClass('is--open');
    hidePreviousContent($(SUB_NAV_MENU));
    openSideNavFocus(opts);
    return;
  }

  if ($currentElement.html() === 'My Settings') {
    const $subNavContainer = $(SUB_NAV_MENU).not('.menu__my-settings');
    $('.main-menu__content').removeClass('u-hide');
    $subNavContainer.removeClass('is--open');
    hidePreviousContent($subNavContainer);
    openSideNavFocus(opts);
    // return;
  }
  if ($currentElement.html() === 'Information' || $currentElement.html() === 'Customer Care' || $currentElement.html() === 'My Revolve') {
    $(SUB_NAV_MENU).removeClass('is--open');
  }
  if (dataElement === 'beauty') {
    parentListDataId = 'beauty';
  }
  // Conditional to check if menu is already built
  if (!subMenu.length) { // if subMenu does not exist build it - subMenuListId !== parentListDataId
    const newList = generateMarkup(
      $currentElement,
      dataElement,
      properDataElement,
      dataLevel,
      dataCategory,
      properDataCategory,
      $parentList,
      parentListDataId,
      parentWrapperElement,
      wrapperHeight,
      lastWrapperHeight,
      opts);
    $(MAIN_NAV).append(newList);

    // setTimeout allows for the slide in effect to occur
    setTimeout(() => {
      const $subNavList = $currentElement.closest('.nav-side__list');
      const $mainContent = $currentElement.closest('.main-menu__content').length;
      if ($mainContent) {
        hidePreviousContent($(newList), $('.main-menu__content'));
      } else {
        hidePreviousContent($(newList), $subNavList);
      }
      $(newList).addClass('is--open');
    }, 200);
    scrollToTop($el);
  } else {
    // Check if Existing Menu has global elements
    if (!subMenu.find(GLOBAL_CLASS).length) {
      if ($(GLOBAL_CLASS)[0]) { // check if any gloabl menus are present
        // clone my account and customer care list
        const globalNavigation = cloneGLobalElements();
        if ($currentElement.html() !== 'My Settings') {
          const globalAccountNavigation = cloneGLobalAccountElements(parentListDataId === 'mens' || dataElement === 'mens');
          appender(subMenu[0], globalAccountNavigation[0]);
        }
        appender(subMenu[0], globalNavigation[0]);
      }
    }
    toggleMenuClass(
      $el,
      $currentElement,
      wrapperHeight,
      lastWrapperHeight,
      opts);
    scrollToTop($el);
  }
  setTimeout(() => {
    // Get the last sub menu with the class of is--open
    openSideNavFocus(opts);
  }, 400);
  // Hacky way to help with categories that are in multiple levels.
  // It gets the data-swap-target of the clicked category, before going to next level
  // Then, it replaces the back button's data-swap-target
  const isBackButton = $currentElement.hasClass('js-rich-nav-back');

  // getDataCategory was added because in the main menu wrapper (.main-menu__wrapper)
  // there's a class womens-menu__womens,
  // and this classes is used as well in Women's category level.
  // so the check ensures that it won't go straight to the main menu if you're clicking back if
  // you're deep into multiple categories.
  const getDataCategory = $currentElement.closest('.sub-menu__list').data('category');
  if (!isBackButton && getDataCategory !== 'womens') {
    const getDataId = $currentElement.closest('.sub-menu__list').data('id');
    const dataSwapTarget = $currentElement.data('swapTarget');
    const getDataElement = $currentElement.closest('.js-menu-wrapper').data('element');
    if (!getDataElement) return;
    // this grabs the main text from the menu, the text is always at the second li element.
    const getText = $currentElement.closest('.js-menu-wrapper').find('ul').children('li').eq(1)
      .text();
    const newSwapTarget = `.${getDataId}-menu__${getDataElement}`;
    $(dataSwapTarget).find('.js-rich-nav-back').data('swapTarget', newSwapTarget).html(getText);
  }
};

/**
 * Bind a keyup event to the document to listen for the Escape key.
 * If pressed, it will close the side nav and focus the burger icon.
 * @param  {Object} opts - Object containing the releaseFocusFunc & returnFocus string
 * @return {undefined}
 */
function bindEscKeyEventOnOpenSideNav(event, opts) {
  const $elTarget = $(event.target);
  $(document).on('keyup.closeSideNav', (e) => {
    if (e.key === 'Escape') { // escape key maps to keycode `27`
      if ($('.nav__sidebar--open').length === 0) return;
      // return focus to element that triggered the rich nav
      $elTarget.focus();
      closeSideNav(opts);
      unbindEscKeyEvent();
    }
  });
}

/**
 * Unbinds the keyup event handler from the document.
 * @return {undefined}
 */
function unbindEscKeyEvent() {
  $(document).off('keyup.closeSideNav');
}

/**
 * Applies any sort of event handlers for the richNav.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = ($el, wrapperHeight, opts = {}) => {
  const { rnItem } = opts;
  $el.on(CLICK_EVENT, rnItem, (evt) => {
    evt.preventDefault();
    itemClickHandler(
      evt,
      $el,
      wrapperHeight,
      opts);
  });
  // Open or Close Rich Nav
  $burgerIcon.on(CLICK_EVENT, (e) => {
    openSideNav(opts);

    // Close Rich Nav with Escape Key
    bindEscKeyEventOnOpenSideNav(e, opts);
  });

  // PLP Cateroy Rich Nav Link
  $plpCatNavLink.on(CLICK_EVENT, (e) => {
    openSideNav(opts);

    // Close Rich Nav with Escape Key
    bindEscKeyEventOnOpenSideNav(e, opts);
  });

  // Close side nav with Keyboard - Accessibility
  $(document).on(CLICK_EVENT, '.js-rich-nav-close', (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    $('#tr-burger-icon').focus();
    closeSideNav(opts);
  });

  // Close Side Nav Sign In with Keyboard - Accessibility
  $(document).on(CLICK_EVENT, '.js-signin-close', (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }
    $('#tr-burger-icon').focus();
    closeSideNav(opts);
  });

  // Close side nav with Overlay
  $('#js-nav-side__overlay').on(CLICK_EVENT, () => {
    closeSideNav(opts);
  });

  // close all sub menus when tabs are clicked
  $el.on(CLICK_EVENT, '.tabs__link', (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }

    removeAllSubMenus();
  });
};

function getMenuData(storeData, onDataGet) {
  if (sessionStorage.getItem(storeData)) {
    const data = JSON.parse(sessionStorage.getItem(storeData));
    onDataGet(data);
  } else {
    fetch(WOMENS_ENDPOINT_URL, { credentials: 'same-origin' })
    .then(handleErrors)
    .then(response => response.json())
    .then((data) => {
      // set data in local storage
      sessionStorage.setItem(storeData, JSON.stringify(data));
      onDataGet(data);
    })
    .catch((error) => {
      console.log(error);// eslint-disable-line no-console
    });
  }
}

function buildBeautyTabMenuList(data) {
  const cats = data.find(obj => obj.id === '--categories--');
  if (cats && cats.subCategoryList) {
    const beautyData = cats.subCategoryList.find(obj => obj && obj.id === '-c-beauty--');
    if (beautyData && beautyData.subCategoryList) {
      const id = beautyData.category;
      const category = id;
      const catName = getTranslatedText(beautyData.catName);
      const ul = buildListElement('ul', id, category, catName);
      beautyData.subCategoryList.forEach(element => {
        const li = buildListItemElement('li');
        if (element.isSubHeader) {
          li.className = 'nav-side__item nav-side__item--sub-title';
          li.textContent = element.catName;
        } else if (element.subCategoryList) {
          const btn = createNode('button');
          const categoryName = element.catName.replace(/[^A-Z0-9]/ig, '-');
          btn.className = 'nav-side__link nav-side__link--category js-rich-nav';
          btn.dataset.swapClass = 'is--open';
          btn.dataset.swapTarget = `.beauty-menu__${categoryName}`;
          btn.dataset.element = categoryName;
          btn.dataset.level = element.level;
          btn.innerHTML = element.nameDisplay;
          appender(li, btn);
        } else {
          const a = createNode('a');
          a.href = element.href;
          a.className = 'nav-side__link';
          a.innerHTML = element.nameDisplay;
          appender(li, a);
        }
        appender(ul, li);
      });
      appender($('#beauty-menu__content')[0], ul);
    }
  }
}

function getBeautyTabContent() {
  const $beautyMenuContent = $('#beauty-menu__content');
  if ($beautyMenuContent.length && $.trim($beautyMenuContent.html()) === '') {
    // The div is empty, add your logic here
    getMenuData('womens-data', buildBeautyTabMenuList);
  }
}

/**
* Initializes richNav.
* @param {HTMLElement} el - link
* @param {Object} options - Options used for wiring up the modal
* @see DEFAULTS
*/
export default function richNav(el, options = {}) {
  const $el = $(el);
  const mainWrapper = $(MAIN_NAV);
  const wrapperHeight = mainWrapper.outerHeight(true);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventHandlers(
   $el,
   wrapperHeight,
   opts);
  $('.js-tabs').tabs();
  getBeautyTabContent();
  openDefaultMenu();
}
registerJQueryPlugin(PLUGIN_NAME, richNav);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/rich-nav.js